module.exports = __webpack_public_path__ + "img/bg-trailer.4449f9f4.jpg";